import { defineStore } from 'pinia'

import type { DisciplineBalancesStore } from './interfaces'

import { emptyDisciplineBalancesFilters } from '../../../lib/discipline-balances-query'
import { actions } from './actions'
import { getters } from './getters'

export const useDisciplineBalancesStore = defineStore('discipline-balances', {
  state: (): DisciplineBalancesStore => ({
    loading: false,
    balances: [],
    meta: null,
    filters: emptyDisciplineBalancesFilters(),
    currentPage: 1,
    perPage: 25,
    modalOpen: false,
  }),
  actions,
  getters,
})
